
import { size } from 'lodash-es'
import { Component, Prop, Vue } from 'vue-property-decorator'
import ChoiceIcon from '~/components/common/icon/ChoiceIcon.vue'

@Component({
  components: {
    ChoiceIcon
  }
})
export default class RadioSet extends Vue {
  @Prop({ type: Array, required: true }) options!: any[]
  @Prop({ type: [String, Object, undefined], default: undefined }) value!: any
  @Prop({ type: String, default: 'test' }) dataTestPrefix!: string
  @Prop({ type: Function, default: arg => arg.label }) labelMapper!: <Type>(arg: Type) => string
  @Prop({ type: Function, default: arg => arg.value }) valueMapper!: <Type>(arg: Type) => string

  size = size

  get isSelected() {
    return arg => this.valueMapper(arg) === this.valueMapper(this.value)
  }
}
